import React from "react";
import { motion } from "framer-motion";

// 1. We set a default empty string for 'text' to prevent the crash
export const RevealText = ({ text = "", delay = 0, speed = 0.05 }) => {
  
  // 2. Safety Check: If text is still undefined or not a string, do not render anything
  if (!text || typeof text !== "string") {
    return null; 
  }

  const containerVars = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: speed,
        delayChildren: delay,
      },
    },
  };

  const letterVars = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1, 
      transition: { duration: 0.01 } 
    },
  };

  return (
    <motion.div
      variants={containerVars}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-10%" }} // Triggers when 10% of element is in view
      className="inline-block" // Ensures it behaves like text
    >
      {text.split("").map((char, index) => (
        <motion.span
          key={index}
          variants={letterVars}
          // Use 'whitespace-pre-wrap' to ensure spaces between words are respected
          className="inline-block whitespace-pre-wrap" 
        >
          {char}
        </motion.span>
      ))}
    </motion.div>
  );
};

export default RevealText;